import { useParams } from 'react-router-dom'
import Dropdown from '../../../../UI/Dropdown/Dropdown'
import useLoadControllingKostenstellen from '../../../../hooks/Controlling/useLoadControllingKostenstellen'
import { Moment } from 'moment'
import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'

type Props = {
  yearMoment: Moment
}

const SelectKostenstelle: React.FC<Props> = ({ yearMoment }) => {
  const { companyUUID, kostenstelleUUID } = useParams()
  const [kostenstellen] = useLoadControllingKostenstellen()
  const t = useSelector((s) => s[props.TRANSLATION])

  const update = (kostenstelleUUID: string) => {
    const year = yearMoment.year()
    window.location.href = `/admin/controlling/${companyUUID}/${kostenstelleUUID}/${year}`
  }

  if (!yearMoment || !kostenstellen) return null
  return (
    <Dropdown
      label={t.controlling.yearSelection.konstenstellenSwitch}
      value={kostenstelleUUID}
      items={kostenstellen.map((k) => ({ label: k.name, value: k.uuid }))}
      onChange={update}
      required
    />
  )
}

export default SelectKostenstelle
